var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:[
    {
      'checked-input': _vm.value,
      'disabled-input': _vm.disabled
    },
    _vm.typeInput
  ]},[_c('input',{staticClass:"input",attrs:{"disabled":_vm.disabled,"type":_vm.typeInput,"name":_vm.name},domProps:{"checked":_vm.value},on:{"change":function($event){return _vm.$emit('input', _vm.typeInput === 'radio' ? _vm.value : !_vm.value)},"click":function($event){return _vm.$emit('change', $event)}}}),_c('div',{staticClass:"label",class:{
      'label--checked': _vm.value,
      'label--disabled': _vm.disabled
    }})])
}
var staticRenderFns = []

export { render, staticRenderFns }